import React, { useEffect, useState } from "react";

import storelogo from "./logo-bitchingham-1.png";
import "./App.css";
import InventoryTable from "./components/inventoryTable";
import InputForm from "./components/inputForm";
import {
  getItemList,
  setItemCount,
  addItem,
  deleteItem,
} from "./services/itemlist";

function App() {
  const [alert, setAlert] = useState(0);
  const [itemList, setItemList] = useState([]);
  const [hiddenItemList, setHiddenItemList] = useState([]);
  const [selName, setSelName] = useState("");
  const [selSize, setSelSize] = useState(0);
  const [selUnit, setSelUnit] = useState("");
  const [selCount, setSelCount] = useState(0);
  const [selUPC, setSelUPC] = useState(0);
  const [selId, setSelId] = useState(0);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [inputHighlight, setInputHighlight] = useState("");
  const [filterItemName, setFilterItemName] = useState("");
  const [filterItemCount, setFilterItemCount] = useState(0);
  const [filterItemOp, setFilterItemOp] = useState(1);

  useEffect(() => {
    getItemList()
      .then((items) => {
        items.sort((a, b) =>
          a.productName.toLowerCase() > b.productName.toLowerCase() ? 1 : -1
        );
        let filtItems = items.filter((item) => {
          const regex = new RegExp(filterItemName, "gi"); // handle string match on item name
          let matched = item.productName.match(regex);
          if (matched && matched.length) {
            switch (filterItemOp) {
              case -1:
                return item.count < filterItemCount;
                break;
              case 0:
                return item.count == filterItemCount;
                break;
              default:
                return item.count >= filterItemCount;
            }
          }
        });

        setItemList(filtItems);
        setHiddenItemList(items.filter((x) => x.count < 0));
      })
      .catch((err) => console.log("Failed to fetch item list: ", err));
    setAlert(false);
  }, [alert, filterItemName, filterItemCount, filterItemOp]);

  const filterItemList = (list) => {
    const regex = new RegExp(filterItemName, "gi"); // handle string match on item name

    let filteredItems = list.filter((item) => {
      let matched = item.productName.match(regex);

      if (matched && matched.length) {
        switch (filterItemOp) {
          case -1:
            return item.count < filterItemCount;
            break;
          case 0:
            return item.count == filterItemCount;
            break;
          default:
            return item.count >= filterItemCount;
        }
      }
    });
    return filteredItems;
  };

  const handleDeleteItem = (id) => {
    deleteItem(id)
      .then(() => {
        setAlert(true);
      })
      .catch((result) => {
        console.log("ERROR: item not deleted: ", result);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData(document.querySelector("#" + event.target.id));
    const newItemId = parseInt(formData.get("productId"));
    const newItemCount = parseInt(formData.get("count"));

    // Remove items that were needed only for existing item selection rather than addItem
    formData.delete("productId");
    formData.delete("existing-item");

    const stockItem = hiddenItemList.filter(
      (item) => parseInt(item.id) === newItemId
    ).length;

    if (stockItem) {
      setItemCount(newItemId, newItemCount)
        .then(() => {
          setAlert(true);
          return true;
        })
        .catch((err) =>
          console.log("Failed to set itemCount. The error was: ", err)
        );
    } else {
      addItem(formData)
        .then((result) => {
          setAlert(true);
        })
        .catch((result) => {
          console.log("Failed to add item. Result = ", result);
        });
    }
    clearForm();

    // return false;
  };

  const handleDecrementClick = (target) => {
    getItemList().then((items) => {
      items.every((item) => {
        if (parseInt(item.id) === parseInt(target)) {
          item.count--;
          setItemCount(item.id, item.count);
          return false;
        }
        return true;
      });

      setItemList(items);
      setHiddenItemList(items.filter((x) => x.count < 0));
    });
  };

  const handleIncrementClick = (target) => {
    getItemList().then((items) => {
      items.every((item) => {
        if (parseInt(item.id) === parseInt(target)) {
          item.count++;
          setItemCount(item.id, item.count);
          return false;
        }
        return true;
      });

      setItemList(items);
    });
  };

  const handleItemSelect = (item) => {
    const { id, productName, productSize, productSizeUnit, UPC } = JSON.parse(
      item.target.value
    );

    setSelName(productName);
    setSelSize(productSize);
    setSelUnit(productSizeUnit);
    setSelCount(0);
    setSelUPC(UPC);
    setSelId(id);
    setInputHighlight(true);
    setSubmitDisabled(false);

    document.getElementById("productName").disabled = true;
    document.getElementById("productSize").disabled = true;
    document.getElementById("productSizeUnit").disabled = true;
    document.getElementById("upc").disabled = true;
  };

  function clearForm() {
    setSelName("");
    setSelSize("");
    setSelUnit("");
    setSelCount("");
    setSelUPC("");
    setSelId(0);
    setSubmitDisabled(true);
    setInputHighlight(false);
    document.getElementById("productName").disabled = false;
    document.getElementById("productSize").disabled = false;
    document.getElementById("productSizeUnit").disabled = false;
    document.getElementById("upc").disabled = false;
  }

  const handleReset = (event) => {
    // console.log("handleReset()");
    event.preventDefault();
    clearForm();
  };

  const handleFormUpdate = (x) => {
    // console.log("handleFormUpdate: x", x);
    switch (x.target.id) {
      case "productName":
        setSelName(x.target.value);
        break;
      case "productSize":
        setSelSize(x.target.value ? parseInt(x.target.value) : "");
        break;
      case "productSizeUnit":
        setSelUnit(x.target.value);
        break;
      case "count":
        setSelCount(x.target.value ? parseInt(x.target.value) : "");
        break;
      case "upc":
        setSelUPC(x.target.value ? parseInt(x.target.value) : "");
        break;
      default:
        break;
    }
    validateForm();
  };

  const handleProductChange = (event) => {
    console.log("HANDLING PRODUCT NAME CHANGE FROM APP.JS", event.target.value);
    setSelName(event.target.value);
    validateForm(event);
  };

  const handleFilterUpdate = (event) => {
    const { name, value } = event.target;
    console.log("handleFilterUpdate: name=", name, " value=", value);
    if (name === "itemFilterName") {
      setFilterItemName(value);
    }
    if (name === "itemFilterCount") {
      if (Number.isInteger(parseInt(value))) {
        setFilterItemCount(parseInt(value));
      }
      if (value === "") {
        setFilterItemCount(0);
      }
    }
    if (name === "itemFilterOpL") {
      setFilterItemOp(-1);
    }
    if (name === "itemFilterOpE") {
      setFilterItemOp(0);
    }
    if (name === "itemFilterOpGE") {
      setFilterItemOp(1);
    }
  };

  const validateForm = (val) => {
    let formData = new FormData(document.getElementById("item-input-form"));
    const data = new URLSearchParams();

    for (const pair of formData.entries()) {
      data.append(pair[0], pair[1]);
    }

    if (
      formData.get("productName").length &&
      formData.get("productSizeUnit").length &&
      formData.get("UPC").length &&
      parseInt(formData.get("productSize")) > 0 &&
      parseInt(formData.get("count")) > 0
    ) {
      // console.log("form is ready for submission");
      setSubmitDisabled(false);
    } else {
      // console.log("form is NOT ready to be submitted");
    }
  };

  const handleEmail = (event) => {
    event.preventDefault();
    console.group("App.js:: sendList()");
    console.log("event", event);
    console.log("event.target.address", event.target.address.value);
    let to = event.target.address.value;
    // let from = "andy.mitchell@pobox.com";
    let from = "bitchinghams@pantry.afmitchell.com";
    let subject = "Pantry Manager List";

    getItemList().then((items) => {
      console.log("Got itemList", items);
      let emailItems = filterItemList(items);
      console.log("Sending emailItems", emailItems);
      let json = JSON.stringify(emailItems);

      console.group("EMail Message:");
      console.log("To:", to);
      console.log("From:", from);
      console.log("Subject:", subject);
      console.log("Msg:", json);

      let request = new Request(
        "https://pantry.afmitchell.com/service/message.php",
        {
          method: "POST",
          body: JSON.stringify({
            to: to,
            from: from,
            subject: subject,
            msg: json,
          }),
          mode: "cors",
        }
      );

      fetch(request).then(function (data) {
        return;
      });
    });
    console.groupEnd();
  };

  async function postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      body: JSON.stringify(data),
    });
    return response.json();
  }

  const EmailForm = () => (
    <form id="email-form" onSubmit={handleEmail}>
      <button type="submit" name="email">
        Send List to Email
      </button>
      <input
        type="radio"
        id="andy-address"
        name="address"
        value="afmitchell@gmail.com"
      />
      <label htmlFor="andy-address">andy</label>
      <input
        type="radio"
        id="beth-address"
        name="address"
        value="megabethster@gmail.com"
      ></input>
      <label htmlFor="beth-address">beth</label>
    </form>
  );

  return (
    <div>
      <div className="container App">
        <div>
          <img src={storelogo} className="App-logo" alt="logo" />
        </div>
        <InputForm
          onSubmit={handleSubmit}
          onItemSelect={handleItemSelect}
          onFormUpdate={handleFormUpdate}
          onProductChange={handleProductChange} // are we using this anymore?
          onReset={handleReset}
          status={submitDisabled}
          inputHighlight={inputHighlight}
          alert={alert}
          selected={selId}
          items={hiddenItemList}
          selName={selName}
          selSize={selSize}
          selUnit={selUnit}
          selCount={selCount}
          selUPC={selUPC}
          selId={selId}
        />

        <EmailForm />

        <InventoryTable
          items={itemList}
          filterItemCount={filterItemCount}
          filterItemName={filterItemName}
          filterItemOp={filterItemOp}
          handleDecrement={handleDecrementClick}
          handleIncrement={handleIncrementClick}
          handleDelete={handleDeleteItem}
          handleFilterUpdate={handleFilterUpdate}
        />
        {/* <InventoryTable /> */}
      </div>
    </div>
  );
}

export default App;
